<template>
  <div class="login-box">
    <AuthLogo />
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">You forgot your password? Here you can easily retrieve a new password.</p>

        <form action="recover-password.html" method="post">
          <div class="input-group mb-3">
            <input type="email" class="form-control" placeholder="Email">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <button type="submit" class="btn btn-primary btn-block">Request new password</button>
            </div>
            <!-- /.col -->
          </div>
        </form>

        <p class="mt-3 mb-1">
          <a href="javascript:void(0)" @click="goToLogin">Login</a>
        </p>
        <p class="mb-0">
          <a href="javascript:void(0)" @click="goToSignup" class="text-center">Register a new membership</a>
        </p>
      </div>
      <!-- /.login-card-body -->
    </div>
  </div>
</template>

<script>
export default {
  created() {
    document.body.classList.add("login-page");
    document.querySelector("#app").classList.remove("wrapper");
  },
  methods: {
    goToSignup(){
      this.$router.push({name: 'signup'});
    },
    goToLogin(){
      this.$router.push({name: 'login'});
    },

  },
}
</script>

